import $ from 'jquery';

const $store = $({});

$.store = (key, value) => {

    if ( value !== undefined ) {
        $store.data(key, value);
        $.trigger(`store/${key}`, [value]);
    }

    return $store.data(key);

};

